import React, { useEffect, useState, useRef, useMemo } from "react";
import { connect } from "react-redux";
import { Button } from "react-md";
import MGridForm from "components/Shared/MGridForm";
import validator from "components/Shared/MGridFormDefinitions/validator";
import {
  DATA_TYPE_STRING,
  DATA_TYPE_DATE,
} from "typeConstants/dataTypes";
import { CustomerInsightNotificationAddRequest } from "interfaces/Mueller.Business.Models.ts";
import { CUSTOMER_INSIGHT_NOTIFICATION_EDIT, CUSTOMER_INSIGHT_NOTIFICATION_VIEW } from "typeConstants/rights";
import { userHasRight } from "selectors/rights";

interface AddCustomerInsightNotificationProps {
  onCancel: () => void;
  onSubmit: (request: CustomerInsightNotificationAddRequest) => void;
  canViewCustomerDetails: boolean;
  canEditCustomerDetails: boolean;  
}

const customerInsightNotificationAddRequest: CustomerInsightNotificationAddRequest = {
    name: "",
    email: "",
    startDate: null,
    disableDate: null,
};

const AddCustomerInsightNotification = (props: AddCustomerInsightNotificationProps) => {
  const [newCustomerInsightNotification, setNewCustomerInsightNotification] = useState<CustomerInsightNotificationAddRequest>(customerInsightNotificationAddRequest);
  const formControlMethods = useRef({});
  const mounted = useRef(true);

  useEffect(() => {
    return () => {
      mounted.current = false;
    };
  }, []);

  const onAffirm = () => {
    // @ts-ignore
    const isValid = formControlMethods.current.isFormValid();
    if (isValid) {
      let request = { ...newCustomerInsightNotification };
      props.onSubmit(request);
    }
  };

  const onNegate = () => {
    props.onCancel();
  };

  const getAffirmButtonLabel = "Submit";
  const getNegateButtonLabel = "Cancel";

  const onChange = updatedObject => setNewCustomerInsightNotification({ ...updatedObject });

  const memoizedFormDefinition = useMemo(() => {
    const columns = [
    [
      {
        source: "name",
        label: "Name",
        dataType: DATA_TYPE_STRING,
        hasValidationError: validator.required
      },
      {
        source: "email",
        label: "Email",
        value: "",
        dataType: DATA_TYPE_STRING,
        hasValidationError: validator.required          
      },
      {
        source: "startDate",
        label: "Start Date",
        value: null,
        dataType: DATA_TYPE_DATE,
        hasValidationError: validator.required          
      },
      {
        source: "disableDate",
        label: "Disable Date",
        value: null,
        dataType: DATA_TYPE_DATE
      }, 
    ]];  
      return columns;    
    },
    [props.canEditCustomerDetails]
  );

  return (
    <div className="add-customer-insight-notification">
      <MGridForm
        data={newCustomerInsightNotification}
        onChange={onChange}
        formDefinition={memoizedFormDefinition}
        portalTarget={() => document.querySelector(".add-customer-insight-notification-dialog")}
        getControlMethods={cm => { formControlMethods.current = cm; }}
      />
      <div className="button-container">
        <Button
          primary
          raised
          onClick={onNegate}
        >{getNegateButtonLabel}</Button>
        <Button
          primary
          raised
          onClick={onAffirm}
        >{getAffirmButtonLabel}</Button>
      </div>  
    </div>
  );
};

const mapStateToProps = state => ({
  canViewCustomerDetails: userHasRight(CUSTOMER_INSIGHT_NOTIFICATION_VIEW)(state),
  canEditCustomerDetails: userHasRight(CUSTOMER_INSIGHT_NOTIFICATION_EDIT)(state),
});

export default connect(mapStateToProps, null)(AddCustomerInsightNotification);